import {feats} from "../data.js"

let defaultRolls = {
    perk:{common:true,rare:true,epic:true,legendary:true,unique:true},
    feat:{},
    level:{lvl1:true,lvl2:true},
    spellTypes:{damage:true,buff:true,control:true,utility:true,healing:true}
}

export const classRoll = [
    {
        name: "Fighter",
        abilityScores: "14 Str, 12 Dex, 12 Con, 10 Int, 8 Wis, 10 Cha",
        hd:"1d12",
        baseStatsMods:{
            bab:2,
            hdSize:12,
            sp:5,
            spPerLevel:1,
            fortitude:2,
            reflex:0,
            will:0,
            gold:50,
            abilityScores:{
                strength:4,
                dexterity:2,
                constitution:2,
                intelligence:0,
                wisdom:-2,
                charisma:0,
            },
        },
        baseStats: "1d12HD, +2 BAB, 5 SP, 1 SP per level, +2 Fortitude",
        Rolls: `Base Rolls: \n   Perks: 1 Unique, 1 Untyped, 1 Fighter, 1 Class, 1 Recovery\n   Feats: 1 Untyped, 2 Martial, 1 Style \n   Stats: 3 Untyped, 2 Skills \n   Equipment: 4 Weapons, 3 Armor, 50 Gold \n   Maneuvers: 2 Untyped, 1 Typed, 1 Stance, 2 Finishers  \n   Spell Power: -5 universal spell power, -1% universal spell critical chance
        \nBonus Rolls:\n    Every 3 levels: <Flurry/Royal/Technique/Sakura/Primal> Maneuver\n    Every 4 levels: +1 BAB\n    Every 6 levels: Martial Feat`,        
        rollRequests:[
            {type:"perks", options:{rarity:{unique:true}},amount:1},
            {type:"perks", options:{rarity:defaultRolls.perk}, amount:1},
            {type:"perks", options:{rarity:defaultRolls.perk, sub:{fighterPerks:true}}, amount:1},
            {type:"perks", options:{rarity:defaultRolls.perk, sub:{recoveryPerks:true}}, amount:1},
            {type:"feats", amount:1},
            {type:"feats", options:{martial:true}, amount:2},
            {type:"feats", options:{style:true}, amount:1},
            {type:"stats", amount:3},
            {type:"stats", options:{type:{skills:true}}, amount:2},
            {type:"weapon", amount:4},
            {type:"armor", amount:3},
            {type:"maneuver", options:{level:defaultRolls.level}, amount:2},
            {type:"maneuver", options:{type:{Stance:true}, level:defaultRolls.level}, amount:1},
            {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:2},
        ],
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            context.stats.characterStats.spellMastery.spellPower.universal -= 5
            context.stats.characterStats.spellMastery.spellCriticalChance.universal -= 1
            let perks = self.classPerks
            let choices = []
            let chosen = []
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*perks.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                chosen.push(possible)
                let option = perks[possible]
                let description = option.description
                choices[x] = {
                    title:option.name,
                    description,
                    id:x,
                    method:(context =>{
                        if(option.hasCustomMethod) {
                            option.customMethod(context)
                        }
                        if(!option.skipAdd){
                            let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                            context.stats.lists.perks.push(perk)
                        }
                    })
                }                
            }
            let custom = {title:"Class Perk", options:choices}
            context.customDialogArray.push(custom)
            context.getSpellOrManeuver({name:"Typed Maneuver"})
        },
        bonusRolls:(context)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                let list = ["Flurry", "Royal","Technique","Sakura","Primal"]
                context.getSpellOrManeuver({name:"School Maneuver"}, {school:list})
            }
            if(context.stats.characterStats.misc.level%6 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true}}))
            }
            if(context.stats.characterStats.misc.level%4 == 0){
                context.stats.characterStats.misc.BAB += 1
            }
        },
        classPerks:[
            {
                name:"Fighter's Grit",
                description:"As a swift action you can spend spell points equal to twice the maneuver's level to recover it.",
            },
            {
                name:"Warrior's Gambit",
                description:"Gain a gambit.",
                hasCustomMethod:true,
                skipAdd:true,
                customMethod:(context)=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Gambit"}))
                }
            },
            {
                name:"Spark of Battle",
                description:"When you score a critical hit with a weapon attack you recover 1 maneuver. This can only activate once per round. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
            },
            {
                name:"Battle Tactician",
                description:"When you use a successful counter you recover a single strike. When you use a successful strike you recover a single counter. If you use a boost, you can recover either a strike or a counter. 'Successful' includes the strike or counter completing its intended use. You can only recover a single maneuver from activation of either of these.",
            },
            {
                name:"Improved Expertise",
                description:"Whenever you use an ability that recovers maneuvers equal to your highest mental modifier (or more), you recover an additional 3 maneuvers. When you use a perk that recovers less than that, you recover one additional maneuver. Any maneuver recovered this way must match the requirements of the ability or perk that was recovering maneuvers (eg: recover a counter, you can recover an additional counter.)",
            },
            {
                name:"Fighter's Stamina",
                description:"You gain stamina equal to your constitution modifier. Once per round you can expend 1 stamina as a free action to recover a single maneuver. Temporary changes to your constitution do not grant more stamina. Your stamina recovers at the start of every floor. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
            },            
            {
                name:"Flowing Techniques",
                description:"Whenever you change from one martial stance to another you can recover a single maneuver of the school of the stance you just changed into. You can only activate this once per round.",
            },
            {
                name:"Unending Techniques",
                description:"You gain a strike/boost/counter. Every 3 levels you gain another strike/boost/counter.",
                hasCustomMethod:true,
                skipAdd:false,
                customMethod:(context)=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{type:{Strike:true,Boost:true,Counter:true}}}))
                }
            },
            {
                name:"Special Move",
                description:"At the start of each floor you choose a single maneuver, you can recover that maneuver as a swift action. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
            },
        ],
        },
        {
            name: "Barbarian",
            abilityScores: "16 Str, 10 Dex, 14 Con, 7 Int, 9 Wis, 7 Cha",
            hd:"1d12",
            baseStatsMods:{
                bab:1,
                hdSize:12,
                sp:6,
                spPerLevel:1,
                fortitude:2,
                reflex:0,
                will:1,
                gold:25,
                abilityScores:{
                    strength:6,
                    dexterity:0,
                    constitution:4,
                    intelligence:-3,
                    wisdom:-1,
                    charisma:-3,
                },
            },
            baseStats: "1d12HD, +1 BAB, 6 SP, 1 SP per level, +2 Fortitude, +1 Will",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 1 Untyped, 1 Rage, 1 Class, 1 Recovery\n   Feats: 2 Untyped, 1 Martial\n   Stats: 3 Untyped, 1 Skill \n   Equipment: 2 Weapons, 1 R+ Weapon, 1 Armor, 25 Gold \n   Maneuvers: 1 Untyped, 2 Strikes, 1 Finisher  \n   Spell Power: -10 universal spell power, -2% universal spell critical chance, 15% universal spell critical power
            \nBonus Rolls:\n    Every 3 levels: <Primal/Fire/Death/Dark/Heroic> Maneuver or Damage Spell\n    Every 3 levels: +1 Strength\n    Every 8 levels: Rage Power`,             
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{recoveryPerks:true}}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{ragePerks:true}}, amount:1},
                {type:"feats", amount:2},
                {type:"feats",  options:{martial:true}, amount:1},
                {type:"stats", amount:3},
                {type:"stats", options:{type:{skills:true}}, amount:1},
                {type:"weapon", amount:2},
                {type:"weapon", amount:1, options:{weapon:{rarity:{rare:true,epic:true,legendary:true,unique:true}}}},
                {type:"armor", amount:1},
                {type:"maneuver", options:{level:defaultRolls.level}, amount:1},
                {type:"maneuver", options:{level:defaultRolls.level, type:{Strike:true},}, amount:2},
                {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:1},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.universal -= 10
                context.stats.characterStats.spellMastery.spellCriticalChance.universal -= 2
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 15
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Primal', 'Fire', 'Death', 'Dark', 'Heroic']
                    let spellList = ['damage']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)
                }
                if(context.stats.characterStats.misc.level%4 == 0){
                    context.stats.characterStats.abilityScore.strength += 1
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Rage Power"}))
                }
                
            },
            classPerks:[
                {
                    name:"Surging Power",
                    description:"At the start of your turn you can use your swift action or movement action to recover a random maneuver. You cannot use a maneuver the round you recover it. You can spend spell points equal to half your highest level maneuver known to reduce it to a free action. You can only use this ability once per round.",
                },
                {
                    name:"Thirst for Battle",
                    description:"Whenever you personally defeat a creature you recover a single maneuver. When you complete a combat you recover initiation modifier maneuvers (minimum 1).",
                },
                {
                    name:"Spark of Battle",
                    description:"When you score a critical hit with a weapon attack, you recover 1 maneuver. This can only activate once per round. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Thirst for Revenge",
                    description:"If you take damage that brings you from above to below 0 hit points you recover a single maneuver. When a creature scores a critical hit against you, you recover initiation modifier maneuvers (minimum 1). If you are killed, you recover twice your initiation modifier maneuvers (minimum 2).",
                },
                {
                    name:"Shrug It Off",
                    description:"As a movement action you gain temporary hit points equal to your HD and recover a single expended maneuver. The temporary hit points last 1 round, plus an additional round every 4 levels. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Executioner",
                    description:"If you coup-de-grace an enemy, you recover your highest mental modifier of expended maneuvers.",
                },
                {
                    name:"Fighter's Stamina",
                    description:"You gain stamina equal to your constitution modifier. You can expend 1 stamina as a free action to recover a single maneuver. Temporary changes to your constitution do not grant more stamina. Your stamina recovers at the start of every floor. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Hardy",
                    description:"You gain 2 constitution. The amount of negative hit points you need to be reduced to in order to be killed is increased to 2x your constitution score.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.abilityScore.constitution += 2
                    }
                },
                {
                    name:"Unending Techniques",
                    description:"You gain a strike/boost/counter. Every 3 levels you gain another strike/boost/counter.",
                    hasCustomMethod:true,
                    skipAdd:false,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{type:{Strike:true,Boost:true,Counter:true}}}))
                    }
                },
            ],
        },
        {
            name: "Rogue",
            abilityScores: "8 Str, 15 Dex, 10 Con, 10 Int, 10 Wis, 13 Cha",
            hd:"1d10",
            baseStats: "1d10HD, +2 BAB, 6 SP, 1.5 SP per level, +3 Reflex",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 3 Untyped, 1 Rogue, 1 Class, 1 Recovery\n   Feats: 2 Untyped, 1 Style \n   Stats: 2 Untyped, 5 Skills \n   Equipment: 3 Weapons, 2 Armor, 100 Gold \n   Maneuvers: 2 Untyped, 1 Boost, 1 Counter, 2 Finishers  \n   Spell Power: 1% universal spell critical chance
            \nBonus Rolls:\n    Every 3 levels: <Sakura/Shadow/Death/Flurry/Void> Maneuver or Utility Spell\n    Every 5 levels: +1 BAB\n    Every 8 levels: Rogue Perk`,        
            baseStatsMods:{
                bab:2,
                hdSize:10,
                sp:6,
                spPerLevel:1.5,
                fortitude:0,
                reflex:3,
                will:0,
                gold:100,
                abilityScores:{
                    strength:-2,
                    dexterity:5,
                    constitution:0,
                    intelligence:0,
                    wisdom:0,
                    charisma:3,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:3},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{recoveryPerks:true}}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{roguePerks:true}}, amount:1},
                {type:"feats", amount:2},
                {type:"feats", amount:1, options:{style:true}},
                {type:"stats", amount:2},
                {type:"stats", options:{type:{skills:true}}, amount:5},
                {type:"weapon", amount:3},
                {type:"armor", amount:2},
                {type:"maneuver", options:{level:defaultRolls.level}, amount:2},
                {type:"maneuver", options:{type:{Boost:true}, level:defaultRolls.level}, amount:1},
                {type:"maneuver", options:{type:{Counter:true}, level:defaultRolls.level}, amount:1},
                {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:2},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Sakura', 'Shadow','Death','Flurry','Void']
                    let spellList = ['utility']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    context.stats.characterStats.misc.BAB += 1
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Rogue Talent"}))
                }
            },
            classPerks:[
                {
                    name:"Ambusher",
                    description:"When you attack an enemy that you are flanking, you can recover a single maneuver. In order to use this, you must actually be flanking the creature, not just an ability that lets you act like you are flanking it (such as abilities that let you flank regardless of positioning, or treating a creature like you are flanking it). You cannot recover more than 1 maneuver a round this way, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Headhunter",
                    description:`As a swift action you can choose a single enemy you can see within close range (25ft. + 5ft./2 levels). The creature becomes marked for level/2 rounds. If you personally defeat the creature within those rounds, you recover a single maneuver. You can only have a single creature marked this way at a time. You deal 1 point of sneak attack damage to the creature, increasing by 1 point every 4 levels. If you gain the ability to claim a creature, this ability is activated as a part of claiming a creature.`,
                },
                {
                    name:"Rogue's Gambit",
                    description:"Gain a gambit.",
                    hasCustomMethod:true,
                    skipAdd:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Gambit"}))
                    }
                },
                {
                    name:"Roll the Dice",
                    description:`As a swift action you can roll a 1d6. depending on the result, a different effect occurs:
                    \n1: A random maneuver is expended\n2: Choose 1 maneuver to become expended \n3: Recover a random maneuver\n4: Choose a maneuver to recover\n5: Choose a maneuver to recover and roll again.\n6: Choose a maneuver to recover and regain your swift action.`,
                },
                {
                    name:"Buy Off the DM",
                    description:"You can expend 1 gold per the maneuver's level to recover it. Doing so can be done at any point with no action, but you cannot recover a maneuver more than once per round.",
                },                
                {
                    name:"Executioner",
                    description:"If you coup-de-grace an enemy you recover your highest mental modifier of expended maneuvers (minimum 2).",
                },
                {
                    name:"I Love Stuff",
                    description:"Whenever you buy something you recover highest mental modifier expended maneuvers (minimum 2).",
                },
                {
                    name:"Squirrelly",
                    description:"Whenever you use a successful counter you recover a different counter. You cannot recover a counter this way more than once per floor until you have recovered it again another way.",
                },
                {
                    name:"Special Move",
                    description:"At the start of each floor you choose a single maneuver, you can recover that maneuver as a swift action. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Carrying Gold",
                    description:"Start the game with an additional 75 gold.",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.gold += 75
                    }
                },
            ],
        },
        {
            name: "Tank",
            abilityScores: "12 Str, 12 Dex, 14 Con, 8 Int, 10 Wis, 10 Cha",
            hd:"1d14",
            baseStats: "1d14HD, +1 BAB, 4 SP, 1 SP per level, +2 Fortitude, +1 Will +1 Reflex",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 1 Untyped, 1 Fighter, 1 Class, 1 Recovery\n   Feats: 2 Untyped\n   Stats: 4 Untyped, 2 Skills\n   Equipment: 3 Weapons, 4 Armor, 50 Gold \n   Maneuvers: 2 Untyped, 2 Counters, 1 Finisher  \n   Spell Power: -15 universal spell power, 15 positive spell power, -1% universal spell critical chance
            \nBonus Rolls:\n    Every 3 levels: <Heroic/Guardian/Light/Fire> Maneuver or Buff Spell\n    Every 4 levels: +1 Constitution\n    Every 5 levels: +1 BAB`,        
            baseStatsMods:{
                bab:1,
                hdSize:14,
                sp:4,
                spPerLevel:1,
                fortitude:2,
                reflex:1,
                will:1,
                gold:50,
                abilityScores:{
                    strength:2,
                    dexterity:2,
                    constitution:4,
                    intelligence:-2,
                    wisdom:0,
                    charisma:0,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{fighterPerks:true}}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{recoveryPerks:true}}, amount:1},
                {type:"feats", amount:2},
                {type:"feats",  options:{martial:true}, amount:1},
                {type:"stats", amount:4},
                {type:"stats", options:{type:{skills:true}}, amount:2},
                {type:"weapon", amount:3},
                {type:"armor", amount:4},
                {type:"maneuver", options:{level:defaultRolls.level}, amount:2},
                {type:"maneuver", options:{type:{Counter:true}, level:defaultRolls.level}, amount:2},
                {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:1},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.universal -= 15
                context.stats.characterStats.spellMastery.spellPower.positive += 15
                context.stats.characterStats.spellMastery.spellCriticalChance.universal -= 1
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                if(option.hasCustomMethod) perk.hasCustomMethod = true
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Heroic', 'Guardian','Light','Fire']
                    let spellList = ['buff']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)                       
                }
                if(context.stats.characterStats.misc.level%4 == 0){
                    context.stats.characterStats.abilityScore.constitution += 1
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    context.stats.characterStats.misc.BAB += 1
                }
            },
            classPerks:[
                {
                    name:"Powerful Bonds",
                    description:"If a party member (other than you) is brought from above to below 0 hit points, or suffers from a critical hit, you recover a single maneuver. If an ally is killed (other than you), you recover initiation modifier maneuvers (minimum 2).",
                },
                {
                    name:"Patch Up",
                    description:"As a movement action you can heal yourself or an adjacent ally hit points equal to your ranks in heal and recover a single maneuver. You cannot use this on an ally more than once per floor, but you can use it on yourself once per combat. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Second Wind",
                    description:"You can only use this while below 33% of your hit points. As a swift action you can heal yourself 1d6 hit points and recover a single maneuver. You cannot use this again until you are brought above 33% hit points. Every 4 levels the healing increases by 1d6.",
                },
                {
                    name:"Guardian",
                    description:"As a movement action you can grant adjacent allies a shield bonus to their armor class equal to your shield's base armor class for 1 round (as long as they stay adjacent to you), and recover a single maneuver. You lose your shield's armor bonus to your armor class during this duration. If you take the total defense action, you recover 2 maneuvers. For both recovery options, you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it, nor can you use both in the same turn. When you use either option, you can choose to gain 1 <guardian> combo point.",
                },
                {
                    name:"Fighter's Stamina",
                    description:"You gain stamina equal to your constitution modifier. You can expend 1 stamina as a free action to recover a single maneuver. Temporary changes to your constitution do not grant more stamina. Your stamina recovers at the start of every floor. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Unbreakable Defense",
                    description:"Whenever you use a successful counter you can recover a different counter. You cannot recover a counter this way more than once per floor until you have recovered it again another way.",
                },
                {
                    name:"Bolstering Defense",
                    description:"Once per round when an enemy makes an attack against you and misses your armor class by more than 8 or rolls a natural 1 against you, you can recover a single maneuver. If an enemy confirms a critical fumble against you, you restore your highest mental modifier maneuvers (minimum 1).",
                },
                {
                    name:"Hardy",
                    description:"You gain 2 constitution. The amount of negative hit points you need to be reduced to in order to be killed is increased to 2x your constitution score.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.abilityScore.constitution += 2
                    }
                },
            ],
        },
        {
            name: "Ranger",
            abilityScores: "12 Str, 14 Dex, 10 Con, 10 Int, 12 Wis, 6 Cha",
            hd:"1d12",
            baseStatsMods:{
                bab:2,
                hdSize:12,
                sp:5,
                spPerLevel:1,
                fortitude:1,
                reflex:2,
                will:0,
                gold:25,
                abilityScores:{
                    strength:2,
                    dexterity:4,
                    constitution:0,
                    intelligence:0,
                    wisdom:2,
                    charisma:-4,
                },
            },
            baseStats: "1d12HD, +2 BAB, 5 SP, 1 SP per level, +1 Fortitude, +2 Reflex",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 1 Martial, 1 Universal, 1 Class, 1 Recovery\n   Feats: 1 Style\n   Stats: 2 Untyped, 3 Skills\n   Equipment: 2 Weapons, 1 Ranged Weapon, 3 Armor, 25 Gold \n   Maneuvers: 2 Untyped, 1 Boost, 1 Finisher\n   Spells: lvl 1: x1(Buff/Utility)  \n   Spell Power: 10 positive spell power, 1% positive spell critical chance, -15 negative spell power, -2% negative spell critical chance
            \nBonus Rolls:\n    At level 2 Gain a Ranger Fighting Style Feat\n    Every 3 levels <Flurry/Technique/Sakura/Air> Maneuver or a Buff/Healing Spell\n    Every 5 levels +1 BAB`,        
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, type:{martial:true}}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, type:{universal:true}}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{recoveryPerks:true}}, amount:1},
                {type:"feats", options:{style:true}, amount:1},
                {type:"stats", amount:2},
                {type:"stats", options:{type:{skills:true}}, amount:3},
                {type:"weapon", amount:2},
                {type:"weapon", amount:1, options:{weapon:{type:{ranged:true}}}},
                {type:"armor", amount:3},
                {type:"maneuver", options:{level:defaultRolls.level}, amount:2},
                {type:"maneuver", options:{type:{Boost:true}, level:defaultRolls.level}, amount:1},
                {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{utility:true,buff:true}}, amount:1},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.positive += 10
                context.stats.characterStats.spellMastery.spellPower.negative -= 15
                context.stats.characterStats.spellMastery.spellCriticalChance.negative -= 2
                context.stats.characterStats.spellMastery.spellCriticalChance.positive += 1
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Flurry', 'Technique','Sakura','Air']
                    let spellList = ['buff','healing']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level == 2){
                    let choices = [
                        {title:"Two-Weapon Fighting",id:1, method:(context=>{let feat = feats.filter(feat=> feat.name == "Two-Weapon Fighting");feat.id=Math.random();context.stats.lists.feats.push(feat[0])})},
                        {title:"Precise Shot",id:2, method:(context=>{let feat = feats.filter(feat=> feat.name == "Precise Shot"); feat.id=Math.random();context.stats.lists.feats.push(feat[0])})},
                        {title:"Martial Feat",id:3, method:(context=>{context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true}}))})}
                    ]
                    context.customDialogArray.push({title:"Ranger's Fighting Styles", options:choices})
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    context.stats.characterStats.misc.BAB += 1
                }
            },
            classPerks:[
                {
                    name:"Deep Focus",
                    description:"As a swift action you can roll a wisdom ability check, DC = 15 + maneuver's level. On success, you recover the maneuver. You can add any bonuses to concentration checks you have for this roll. You can take a -5 to the roll to reduce the action to a free action. If you fail the check by 8 or more, a random maneuver becomes expended. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Ambusher",
                    description:"When you attack an enemy that you are flanking, you can recover a single maneuver. In order to use this, you must actually be flanking the creature, not just an ability that lets you act like you are flanking it (such as abilities that let you flank regardless of positioning, or treating a creature like you are flanking it). You cannot recover more than 1 maneuver a round this way, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Headhunter",
                    description:`As a swift action you can choose a single enemy you can see within close range (25ft. + 5ft./2 levels). The creature becomes marked for level/2 rounds. If you personally defeat the creature within those rounds, you recover a single maneuver. You can only have a single creature marked this way at a time. You deal 1 point of sneak attack damage to the creature, increasing by 1 point every 4 levels. If you gain the ability to claim a creature, this ability is activated as a part of claiming a creature.`,
                },
                {
                    name:"Favored Enemy",
                    description:`When you gain this, choose one creature type (abberration, animal, construct, dragon, fey, humanoid, magical beast, monsterous humanoid, ooze, plant, undead, vermin, or outsider) If you choose outsider, you must also choose a subtype of outsider. Whenever you attack a creature of your favored type you gain a +2 bonus on attacks and damage against it. Once per round when you make a successful attack against a creature of your favored type, you recover a single manevuer. At level 10 you can select an additional favored enemy type. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.`,
                },
                {
                    name:"Patch Up",
                    description:"As a movement action you can heal yourself or an adjacent ally hit points equal to your ranks in heal and recover a single maneuver. You cannot use this on an ally more than once per floor, but you can use it on yourself once per combat. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Spark of Battle",
                    description:"When you score a critical hit with a weapon attack you recover 1 maneuver. This can only activate once per round. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
            ],
        },
        {
            name: "Monk",
            abilityScores: "13 Str, 13 Dex, 12 Con, 8 Int, 13 Wis, 8 Cha",
            hd:"1d12",
            baseStatsMods:{
                bab:1,
                hdSize:12,
                sp:7,
                spPerLevel:1.5,
                fortitude:2,
                reflex:2,
                will:2,
                gold:25,
                abilityScores:{
                    strength:3,
                    dexterity:3,
                    constitution:2,
                    intelligence:-2,
                    wisdom:2,
                    charisma:-2,
                },
            },
            baseStats: "1d12HD, +1 BAB, 7 SP, 1.5 SP per level, +2 Fortitude, +2 Will, +2 Reflex",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 1 Untyped, 1 Ki, 1 Class, 1 Recovery\n   Feats: 1 Untyped, 1 Martial, 2 Style\n   Stats: 2 Untyped, 2 Skills\n   Equipment: 2 Weapons, 1 Augmenting Weapon, 2 Light Armor, 1 Clothing, 25 Gold \n   Maneuvers: 3 Untyped, 2 Stances, 2 Finishers  \n   Spell Power: 6 universal spell power, -15% universal spell critical power
            \nBonus Rolls:\n    Every 3 levels: <Flurry/Light/Dark/Shadow/Void> Maneuver or Buff/Healing Spell\n    Every 5 levels: +1 BAB\n    Every 8 levels: Ki Perk`,        
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{kiPerks:true}}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{recoveryPerks:true}}, amount:1},
                {type:"feats", amount:1},
                {type:"feats", options:{martial:true}, amount:1},
                {type:"feats", options:{style:true}, amount:2},
                {type:"stats", amount:2},
                {type:"stats", options:{type:{skills:true}}, amount:2},
                {type:"weapon", amount:2},
                {type:"weapon", options:{weapon:{type:{augmenting:true}}}, amount:1},
                {type:"armor", options:{armor:{type:{light:true}}}, amount:2},
                {type:"armor", options:{armor:{type:{clothing:true}}}, amount:1},
                {type:"maneuver", options:{level:defaultRolls.level}, amount:3},
                {type:"maneuver", options:{type:{Stance:true}, level:defaultRolls.level}, amount:2},
                {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:2},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.universal += 6
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal -= 15
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Flurry', 'Light','Dark','Shadow','Void']
                    let spellList = ['healing']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    context.stats.characterStats.misc.BAB += 1
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Ki Power"}))
                }
            },
            classPerks:[
                {
                    name:"Inner Ki",
                    description:"As a swift action you can spend spell points equal to the maneuver's level to recover it.",
                },
                {
                    name:"Deep Focus",
                    description:"As a swift action you can roll a wisdom ability check, DC = 15 + maneuver's level. On success, you recover the maneuver. You can add any bonuses to concentration checks you have for this roll. You can take a -5 to the roll to reduce the action to a free action. If you fail the check by 8 or more, a random maneuver becomes expended. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Fighter's Stamina",
                    description:"You gain stamina equal to your constitution modifier. You can expend 1 stamina as a free action to recover a single maneuver. Temporary changes to your constitution do not grant more stamina. Your stamina recovers at the start of every floor. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },            
                {
                    name:"Flowing Techniques",
                    description:"Whenever you change from one martial stance to another, you can recover a single maneuver of the school of the stance you just changed into. You can only activate this once per round.",
                },
                {
                    name:"Center Self",
                    description:"As a movement action you can heal 1d8 hit points and recover a single maneuver. Every 4 levels the healing increases by 1d8. You can only use this in combat. You can only activate this once per round. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Flowing Energy",
                    description:"Whenever you use a boost, you recover a single strike. Whenever you use a successful counter, you recover a single boost. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Unending Techniques",
                    description:"You gain a strike/boost/counter. Every 3 levels you gain another strike/boost/counter.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{type:{Strike:true,Boost:true,Counter:true}}}))
                    }
                },
                {
                    name:"Special Move",
                    description:"At the start of each floor you choose a single maneuver, you can recover that maneuver as a swift action. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
            ],
        },
        {
            name: "Warpriest",
            abilityScores: "14 Str, 8 Dex, 12 Con, 10 Int, 12 Wis, 10 Cha",
            hd:"1d10",
            baseStats: "1d10HD, +1 BAB, 6 SP, 2 SP per level, +2 Will, +1 Fortitude",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 2 Untyped, Warpriest Domain, 1 Class, 1 Recovery\n   Feats: 1 Untyped, 1 Martial\n   Stats: 2 Untyped, 2 Skills\n   Equipment: 2 Weapons, 3 Armor, 75 Gold \n   Maneuvers: 3 Untyped, 1 Finisher\n   Spells: lvl 1: x3(Buff, Healing, Untyped) \n   Spells Power: 10 positive spell power, 2% positive spell critical chance, -10 elemental spell power, -1% elemental spell critical chance
            \nBonus Rolls:\n    Every 3 levels: <Light/Dark/Guardian/Heroic> Maneuver or Buff/Healing Spell\n    Every 6 levels: +1 BAB or +2 Wisdom\n`,
            baseStatsMods:{
                bab:1,
                hdSize:10,
                sp:6,
                spPerLevel:2,
                fortitude:1,
                reflex:0,
                will:2,
                gold:75,
                abilityScores:{
                    strength:4,
                    dexterity:-2,
                    constitution:2,
                    intelligence:0,
                    wisdom:2,
                    charisma:0,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:3},       
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{recoveryPerks:true}}, amount:1},     
                {type:"feats", amount:1},
                {type:"feats", options:{martial:true}, amount:1},
                {type:"stats", amount:2},
                {type:"stats", options:{type:{skills:true}}, amount:2},
                {type:"weapon", amount:2},
                {type:"armor", amount:3},
                {type:"spell", options:{level:{lvl1:true},type:{buff:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{healing:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"maneuver", options:{level:defaultRolls.level}, amount:3},
                {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:1},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.positive += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.positive += 2
                context.stats.characterStats.spellMastery.spellPower.fire -= 10
                context.stats.characterStats.spellMastery.spellCriticalChance.fire -= 1
                context.stats.characterStats.spellMastery.spellPower.cold -= 10
                context.stats.characterStats.spellMastery.spellCriticalChance.cold -= 1
                context.stats.characterStats.spellMastery.spellPower.acid -= 10
                context.stats.characterStats.spellMastery.spellCriticalChance.acid -= 1
                context.stats.characterStats.spellMastery.spellPower.electricity -= 10
                context.stats.characterStats.spellMastery.spellCriticalChance.electricity -= 1
                let domainPerk = {name:"Warpriest Domain", rarity:"class", id:Math.random(), type:"magic", uiType:"perks", shortDesc:`Unless specified otherwise, each blessing is a standard action to activate and costs level/2 spell points. At level 1 you can use the blessings minor power, at level 8 you can use the major power instead. The DC of blessings is 10 + level/2 + highest mental modifier.`}
                let perk = context.allPerks.find(perk => perk.name == "Fervor")
                context.stats.lists.perks.push(domainPerk)
                perk.getBlessings(context, perk, domainPerk)

                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal", shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Light', 'Dark','Guardian','Heroic']
                    let spellList = ['buff','healing']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%6 == 0){
                    let options = [{title:"+1 BAB",id:0, method:(context)=>{context.stats.characterStats.misc.BAB += 1}}, {title:"+2 Wisdom",id:1, method:(context)=>{context.stats.characterStats.abilityScore.wisdom += 2}}]
                    context.customDialogArray.push({title:"Class Roll Choice", options})                    
                }
                if(context.stats.characterStats.misc.level%10 == 0){
                    let domainPerk = {name:"Warpriest Domain", rarity:"class", id:Math.random(), type:"magic", uiType:"perks", shortDesc:`Unless specified otherwise, each blessing is a standard action to activate and costs level/2 spell points. At level 1 you can use the blessings minor power, at level 8 you can use the major power instead. The DC of blessings is 10 + level/2 + highest mental modifier.`}
                    let perk = context.allPerks.find(perk => perk.name == "Fervor")
                    perk.getBlessings(context, perk,domainPerk)
                    context.stats.lists.perks.push(domainPerk)
                }
                
            },
            classPerks:[
                {
                    name:"Deep Focus",
                    description:"As a swift action you can roll a wisdom ability check, DC = 15 + maneuver's level. On success, you recover the maneuver. You can add any bonuses to concentration checks you have for this roll. You can take a -5 to the roll to reduce the action to a free action. If you fail the check by 8 or more, a random maneuver becomes expended. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Battle Templar",
                    description:"When you successfully cast a spell you can spend a swift action to recover a maneuver that is the same level or lower than the spell cast. If you cast the spell as a swift action or less, you can recover the maneuver as a free action instead. If the spell is a healing or buff spell, it can be a maneuver of levels up to twice the level of the spell cast. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Divine Recovery",
                    description:"As a free action you can expend a spell for the day to recover a maneuver of up to 3x the spells level. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Surging Magic",
                    description:"Whenever you successfully cast a healing spell, you recover a random maneuver. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Powerful Bonds",
                    description:"If a party member (other than you) is brought from above to below 0 hit points, or suffers from a critical hit, you recover a single maneuver. If an ally is killed (other than you), you recover initiation modifier maneuvers (minimum 2).",
                },
                {
                    name:"Patch Up",
                    description:"As a movement action you can heal yourself or an adjacent ally hit points equal to your ranks in heal and recover a single maneuver. You cannot use this on an ally more than once per floor, but you can use it on yourself once per combat.",
                },
                {
                    name:"Guardian",
                    description:"As a movement action you can grant adjacent allies a shield bonus to their armor class equal to your shield's base armor class for 1 round (as long as they stay adjacent to you). You lose your shield's armor bonus to your armor class during this duration. If you take the total defense action, you recover 2 maneuvers. You cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Divine Inspiration",
                    description:"Whenever you recover initiation modifier maneuvers, you can also allow an ally within 30 feet of you to also recover a single maneuver.",
                },
                {
                    name:"Miracle",
                    description:"Whenever you are brought from above to below 0 hit points, you have a 25% chance to heal 1d6 hit points, plus 1d6 per 4 levels and recover initiation modifier maneuvers (minimum 2)",
                },
                {
                    name:"Magical Focus",
                    description:"Gain a spell. Every 4 levels gain an additional spell.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}))
                    }
                },
            ],
        },
        {
            name: "Eldritch Knight",
            abilityScores: "14 Str, 10 Dex, 12 Con, 12 Int, 8 Wis, 10 Cha",
            hd:"1d10",
            baseStats: "1d10HD, +1 BAB, 6 SP, 2 SP per level, +1 Will, +1 Fortitude",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 3 Untyped, 1 Class, 1 Recovery\n   Feats: 1 Untyped, 1 Martial\n   Stats: 2 Untyped, 3 Skills\n   Equipment: 3 Weapons, 3 Armor, 75 Gold \n   Maneuvers: 3 Untyped, 1 Finisher\n   Spells: lvl 1: x2(Buff, Untyped) \n   Spells Power: 5 elemental spell power, 1% elemental spell critical chance, 10% elemental spell critical power, -20 positive spell power, -2% positive spell critical chance
            \nBonus Rolls:\n    Every 3 levels: <Guardian/Arcane/Royal/Primal> Maneuver or Buff/Damage Spell\n    Every 5 levels: +1 BAB Or +1 Intelligence\n    Every 8 levels: Magus Arcana`,
            baseStatsMods:{
                bab:1,
                hdSize:10,
                sp:6,
                spPerLevel:2,
                fortitude:1,
                reflex:0,
                will:1,
                gold:75,
                abilityScores:{
                    strength:4,
                    dexterity:0,
                    constitution:2,
                    intelligence:2,
                    wisdom:-2,
                    charisma:0,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:3},     
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{recoveryPerks:true}}, amount:1},       
                {type:"feats", amount:1},
                {type:"feats",  options:{martial:true}, amount:1},
                {type:"stats", amount:2},
                {type:"stats", options:{type:{skills:true}}, amount:3},
                {type:"weapon", amount:3},
                {type:"armor", amount:3},
                {type:"spell", options:{level:{lvl1:true},type:{buff:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"maneuver", options:{level:defaultRolls.level}, amount:3},
                {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:1},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.positive -= 20
                context.stats.characterStats.spellMastery.spellCriticalChance.positive -= 2
                context.stats.characterStats.spellMastery.spellPower.fire += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.fire += 1
                context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 10
                context.stats.characterStats.spellMastery.spellPower.cold += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.cold += 1
                context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 10
                context.stats.characterStats.spellMastery.spellPower.acid += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.acid += 1
                context.stats.characterStats.spellMastery.spellCriticalDamage.acid += 15
                context.stats.characterStats.spellMastery.spellPower.electricity += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 1
                context.stats.characterStats.spellMastery.spellCriticalDamage.electricity += 10
                
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Guardian', 'Arcane','Fire','Royal','Primal']
                    let spellList = ['buff','damage']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    let options = [{title:"+1 BAB",id:0, method:(context)=>{context.stats.characterStats.misc.BAB += 1}}, {title:"+1 Intelligence",id:1, method:(context)=>{context.stats.characterStats.abilityScore.intelligence += 1}}]
                    context.customDialogArray.push({title:"Class Roll Choice", options})                    
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    let perk = context.allPerks.find(perk => perk.name == "Spell Combat")
                    perk.getPerk(context, perk, 1)
                }
            },
            classPerks:[
                {
                    name:"Bladecaster",
                    description:"When you cast a spell, you can spend a swift action to recover a maneuver that is the same level or lower than the spell cast. If you cast the spell as a swift action or less, you can recover the maneuver as a free action instead. If the spell is a damage or buff spell, it can be a maneuver of levels up to twice the level of the spell cast. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Arcane Recovery",
                    description:"As a free action you can expend a spell for the day to recover a maneuver of up to 3x the spells level. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },                                                
                {
                    name:"Surging Magic",
                    description:"Whenever you successfully cast a damage spell, you recover a random maneuver. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Eldritch Absorbtion",
                    description:"Whenever you succeed on a saving throw against a spell, you recover a single random maneuver. You can only recover the maneuver once per spell cast.",
                },
                {
                    name:"Eldritch Conduit",
                    description:"Whenever you fail on a saving throw against a spell, you recover a single maneuver. You can only recover the maneuver once per spell cast.",
                },
                {
                    name:"Magical Focus",
                    description:"Gain a spell. Every 4 levels gain an additional spell.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}))
                    }
                },
            ],
        },
        {
            name: "Arcane Trickster",
            abilityScores: "8 Str, 14 Dex, 10 Con, 14 Int, 10 Wis, 10 Cha",
            hd:"1d8",
            baseStats: "1d8HD, +1 BAB, 8 SP, 2.5 SP per level, +2 Reflex, +1 Will",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 3 Untyped, 1 Class, 1 Recovery\n   Feats: 1 Untyped, 1 Utility\n   Stats: 1 Untyped, 3 Skills, 1 E+ Skill\n   Equipment: 2 Weapons, 2 Armor, 150 Gold \n   Maneuvers: 2 Untyped, 2 Finishers\n   Spells: lvl 1: x3(Utility, Buff, Untyped), lvl2: x1(Untyped) \n   Spells Power: 2% universal spell critical chance, 10% universal spell critical power
            \nBonus Rolls:\n    Every 3 levels: <Arcane/Curse/Shadow/Void/Death> Maneuver or Control/Utility Spell\n    Every 6 levels: +1 BAB or +2 Intelligence\n    Every 8 levels: Perk`,  
            baseStatsMods:{
                bab:1,
                hdSize:8,
                sp:8,
                spPerLevel:2.5,
                fortitude:0,
                reflex:2,
                will:1,
                gold:150,
                abilityScores:{
                    strength:-2,
                    dexterity:4,
                    constitution:0,
                    intelligence:4,
                    wisdom:0,
                    charisma:0,
                },
            },     
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:3},
                {type:"perks", options:{rarity:defaultRolls.perk, sub:{recoveryPerks:true}}, amount:1},
                {type:"feats", amount:1},
                {type:"feats", options:{martial:true}, amount:1},
                {type:"stats", amount:1},
                {type:"stats", options:{type:{skills:true}}, amount:3},
                {type:"stats", options:{type:{skills:true}, rarity:{epic:true,legendary:true,unique:true,}}, amount:1},
                {type:"weapon", amount:2},
                {type:"armor", amount:2},
                {type:"spell", options:{level:{lvl1:true},type:{utility:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{buff:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"spell", options:{level:{lvl2:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"maneuver", options:{level:defaultRolls.level}, amount:2},
                {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:2},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 2
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 10
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Arcane', 'Curse','Shadow','Void','Death']
                    let spellList = ['control','utility']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%6 == 0){
                    let options = [{title:"+1 BAB",id:0, method:(context)=>{context.stats.characterStats.misc.BAB += 1}}, {title:"+2 Intelligence",id:1, method:(context)=>{context.stats.characterStats.abilityScore.intelligence += 2}}]
                    context.customDialogArray.push({title:"Class Roll Choice", options})                    
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk",}))
                }
            },
            classPerks:[
                {
                    name:"Ambusher",
                    description:"When you attack an enemy that you are flanking, you can recover a single maneuver. In order to use this, you must actually be flanking the creature, not just an ability that lets you act like you are flanking it (such as abilities that let you flank regardless of positioning, or treating a creature like you are flanking it). You cannot recover more than 1 maneuver a round this way, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Headhunter",
                    description:`As a swift action you can choose a single enemy you can see within close range (25ft. + 5ft./2 levels). The creature becomes marked for level/2 rounds. If you personally defeat the creature within those rounds, you recover a single maneuver. You can only have a single creature marked this way at a time. You deal 1 point of sneak attack damage to the creature, increasing by 1 point every 4 levels. If you gain the ability to claim a creature, this ability is activated as a part of claiming a creature.`,
                },                
                {
                    name:"Roll the Dice",
                    description:`As a swift action you can roll a 1d6. depending on the result, a different effect occurs:
                    \n1: a random maneuver is expended\n2: Choose 1 maneuver to become expended. \n3:Recover a random maneuver\n4:Choose a maneuver to recover\n5: Choose a maneuver to recover and roll again.\n6:Choose a maneuver to recover and regain your swift action.`,
                },
                {
                    name:"Buy Off the DM",
                    description:"You can expend 1 gold per the maneuver's level to recover it. Doing so can be done at any point with no action, but you cannot recover a maneuver more than once per round.",
                },                
                {
                    name:"I Love Stuff",
                    description:"Whenever you buy something, you recover highest mental modifier expended maneuvers (minimum 2).",
                },
                {
                    name:"Squirrelly",
                    description:"Whenever you use a successful counter, you recover a different counter. You cannot recover a counter this way more than once per floor until you have recovered it again another way.",
                },
                {
                    name:"Magical Trickster",
                    description:"When you cast a spell, you can spend a swift action to recover a maneuver that is the same level or lower than the spell cast. If you cast the spell as a swift action or less, you can recover the maneuver as a free action instead. If the spell is a utility or damage spell, it can be a maneuver of levels up to twice the level of the spell cast. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Arcane Recovery",
                    description:"As a free action you can expend a spell for the day to recover a maneuver of up to 3x the spells level. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },                                                
                {
                    name:"Surging Magic",
                    description:"Whenever you successfully cast a utility spell, you recover a maneuver. You can only activate this once per round, and you cannot recover a maneuver the same round you use it, or use a maneuver the same round you recover it.",
                },
                {
                    name:"Magical Focus",
                    description:"Gain a spell. Every 4 levels gain an additional spell.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}))
                    }
                },
                {
                    name:"Carrying Gold",
                    description:"Start the game with an additional 75 gold.",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.gold += 75
                    }
                },
            ],
        },
        {
            name: "Prodigy",
            hd:"1d8",
            abilityScores: "10 Str, 10 Dex, 7 Con, 12 Int, 10 Wis, 10 Cha",
            baseStats: "1d8HD, +0 BAB, 14 SP, 2 SP per level, +2 Will",
            Rolls: `Base Rolls: \n   Perks: 2 Unique, 1 Class\n   Feats: 2x Roll Key\n   Stats: 1 Untyped, 1 Skills, 1 E+ Skill\n   Equipment: 2 Weapons, 1 Armor, 175 Gold \n   Maneuvers: 2 Untyped, 1 Finisher\n   Spells: lvl 1: x2(Untyped x2), lvl 2: x1(Untyped) \n   Spells Power: 3% universal spell critical chance, 15% universal spell critical power 15 random spell power
            \nBonus Rolls:\n    Every 4 levels: Typed Maneuver or Spell\n    Every 6 levels: +1 BAB or +2 Intelligence\n    Every 8 levels: Perk`,
            baseStatsMods:{
                bab:0,
                hdSize:8,
                sp:14,
                spPerLevel:2,
                fortitude:0,
                reflex:0,
                will:2,
                gold:175,
                abilityScores:{
                    strength:0,
                    dexterity:0,
                    constitution:-3,
                    intelligence:2,
                    wisdom:0,
                    charisma:0,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:2},
                {type:"stats", amount:1},
                {type:"stats", options:{type:{skills:true}}, amount:1},
                {type:"stats", options:{type:{skills:true}, rarity:{epic:true,legendary:true,unique:true,}}, amount:1},
                {type:"weapon", amount:2},
                {type:"armor", amount:1},
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:2},    
                {type:"spell", options:{level:{lvl2:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"maneuver", options:{level:defaultRolls.level}, amount:2},
                {type:"maneuver", options:{type:{Finisher:true}, level:defaultRolls.level}, amount:1},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 3
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 15
                let spellPower = ['fire', 'cold', 'acid', 'electricity', 'positive', 'negative']
                let randomSpellPower = spellPower[Math.floor(Math.random()*spellPower.length)]
                context.stats.characterStats.spellMastery.spellPower[randomSpellPower] += 15
                context.connection.send(JSON.stringify({command:"requestRoll", type:"feats", rollAmount:6, options:{martial:true, magic:true, utility:true, style:true, metamagic:true, key:true, prereq:true,}}))
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%4 == 0){
                    let options = []
                    options.push({title:"Maneuver from School",id:0, method:(context)=>{context.getSpellOrManeuver({name:"School Maneuver"})}})
                    options.push({title:"Typed Spell",id:1, method:(context)=>{context.getSpellOrManeuver({name:"Typed Spell"})}})
                    context.customDialogArray.push({title:"Class Roll Choice", options})
                }
                if(context.stats.characterStats.misc.level%6 == 0){
                    let options = [{title:"+0.5 BAB",id:0, method:(context)=>{context.stats.characterStats.misc.BAB += 1}}, {title:"+2 Intelligence",id:1, method:(context)=>{context.stats.characterStats.abilityScore.intelligence += 2}}]
                    context.customDialogArray.push({title:"Class Roll Choice", options})                    
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk",}))
                }
            },
            classPerks:[
                {
                    name:"Polymath",
                    description:"Gain a maneuver recovery perk",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Recovery Perk"}))
                    }
                },
                {
                    name:"Magical Expert",
                    description:"Gain 2 spells. Every 3 levels gain an additional spell.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}))
                    }
                },
                {
                    name:"Coward",
                    description:"Increase your constitution by +1.",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.abilityScore.constitution += 1
                    }
                },
                {
                    name:"Spell Point Addict",
                    description:"Increase your base spell points by 6 and gain an additional spell point per level",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.misc.spPerLevel += 1
                        context.stats.characterStats.spellpointIncreases.push(6)
                    }
                },
                {
                    name:"Spell Master",
                    description:"Gain 10 universal spell power and 1% universal spell critical chance.",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.spellMastery.spellPower.universal += 10
                        context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                    }
                },
            ],
        },    
        {
            name: "Wizard",
            abilityScores: "8 Str, 12 Dex, 10 Con, 16 Int, 10 Wis, 10 Cha",
            hd:"1d6",
            baseStats: "1d6HD, 0 BAB, 9 SP, 3 SP per level, +3 Will",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 2 Untyped, 2 Magic, 1 Class\n   Feats: 1 Untyped, 2 Magic\n   Stats: 1 Untyped, 4 Skills\n   Equipment: 1 Weapons, 100 Gold\n   Spells: lvl 1: x5(Control, Buff, Damage, Healing, Untyped), lvl 2: x3(Typed, Untyped 2x) \n   Spells Power: 10 universal spell power, 2% universal spell critical chance
            \nBonus Rolls:\n    Every 3 levels: <Royal/Void/Arcane> Maneuver or Control/Utility/Damage Spell\n    Every 5 levels: +0.5 BAB or +2 Intelligence\n    Every 8 levels: Magic Perk`,
            baseStatsMods:{
                bab:0,
                hdSize:6,
                sp:9,
                spPerLevel:3,
                fortitude:0,
                reflex:0,
                will:3,
                gold:100,
                abilityScores:{
                    strength:-2,
                    dexterity:2,
                    constitution:0,
                    intelligence:6,
                    wisdom:0,
                    charisma:0,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:2},
                {type:"perks", options:{rarity:defaultRolls.perk, type:{magic:true}}, amount:2},
                {type:"feats", amount:1},
                {type:"feats",  options:{magic:true}, amount:2},
                {type:"stats", amount:1},
                {type:"stats", options:{type:{skills:true}}, amount:4},
                {type:"weapon", amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{control:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{buff:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{damage:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{healing:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"spell", options:{level:{lvl2:true},type:defaultRolls.spellTypes}, amount:3},            
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.universal += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 2
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
                context.getSpellOrManeuver({name:"Typed Spell"})
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Royal','Void','Arcane']
                    let spellList = ['control','utility','damage']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    let options = [{title:"+0.5 BAB",id:0, method:(context)=>{context.stats.characterStats.misc.BAB += 0.5}}, {title:"+2 Intelligence",id:1, method:(context)=>{context.stats.characterStats.abilityScore.intelligence += 2}}]
                    context.customDialogArray.push({title:"Class Roll Choice", options})                    
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{magic:true}}}))
                }
            },
            classPerks:[
                {
                    name:"Polymath",
                    description:"Gain a maneuver recovery perk",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Recovery Perk"}))
                    }                    
                },                
                {
                    name:"Magical Expert",
                    description:"Gain a spell. Every 3 levels gain an additional spell.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}))
                    }
                },
                {
                    name:"Powerful Caster",
                    description:"You gain a +2 bonus on spell penetration checks, and you choose one school of magic, increase the DC's of spells from that school by +1.",
                },
                {
                    name:"Enduring Caster",
                    description:"All spells have their spell point cost reduced by 1. This cannot reduce the cost of spells below 1.",
                },
            ],
        },
        {
            name: "Cleric",
            abilityScores: "10 Str, 8 dex, 12 Con, 10 Int, 14 Wis, 12 Cha",
            hd:"1d8",
            baseStats: "1d8HD, 0 BAB, 8 SP, 2.5 SP per level, +2 Will, +1 Fortitude",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 1 Untyped, 1 Magic, 1 Domain, 1 Class\n   Feats: 2 Untyped, 1 Magic\n   Stats: 2 Untyped, 2 Skills\n   Equipment: 1 Weapons, 2 Armor, 50 Gold\n   Spells: lvl 1: x4(Healing x2, Buff, Untyped), lvl 2: x2(Healing, Untyped) \n   Spells Power: 15 positive spell power, 3% positive spell critical chance, 15% positive spell critical power, -10 elemental spell power
            \nBonus Rolls:\n    Every 3 levels: <Light/Dark/Heroic> Maneuver or Healing/Buff Spell\n    Every 5 levels: +2 Wisdom or +0.5 BAB`,
            baseStatsMods:{
                bab:0,
                hdSize:8,
                sp:8,
                spPerLevel:2.5,
                fortitude:1,
                reflex:0,
                will:2,
                gold:50,
                abilityScores:{
                    strength:0,
                    dexterity:-2,
                    constitution:2,
                    intelligence:0,
                    wisdom:4,
                    charisma:2,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:2},
                {type:"perks", options:{rarity:defaultRolls.perk, type:{magic:true}}, amount:1},
                {type:"feats", amount:2},
                {type:"feats",  options:{magic:true}, amount:1},
                {type:"stats", amount:2},
                {type:"stats", options:{type:{skills:true}}, amount:2},
                {type:"weapon", amount:1},
                {type:"armor", amount:2},
                {type:"spell", options:{level:{lvl1:true},type:{healing:true}}, amount:2},
                {type:"spell", options:{level:{lvl1:true},type:{buff:true}}, amount:1},            
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"spell", options:{level:{lvl2:true},type:{healing:true}}, amount:1},
                {type:"spell", options:{level:{lvl2:true},type:defaultRolls.spellType}, amount:1},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.positive += 15
                context.stats.characterStats.spellMastery.spellCriticalChance.positive += 3
                context.stats.characterStats.spellMastery.spellCriticalDamage.positive += 15
                context.stats.characterStats.spellMastery.spellPower.fire -= 10
                context.stats.characterStats.spellMastery.spellPower.cold -= 10
                context.stats.characterStats.spellMastery.spellPower.acid -= 10
                context.stats.characterStats.spellMastery.spellPower.electricity -= 10
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)

                let perk = context.allPerks.find(perk => perk.name == "Cleric Domain")
                let pushedPerk = JSON.parse(JSON.stringify(perk))
                pushedPerk.id = Math.random()
                context.stats.lists.perks.push(pushedPerk)
                perk.catchUpMethod(context, perk, pushedPerk, 1)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Light', 'Dark','Heroic']
                    let spellList = ['healing','buff']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    let options = [{title:"+0.5 BAB",id:0, method:(context)=>{context.stats.characterStats.misc.BAB += 0.5}}, {title:"+2 Wisdom",id:1, method:(context)=>{context.stats.characterStats.abilityScore.wisdom += 2}}]
                    context.customDialogArray.push({title:"Class Roll Choice", options})                    
                }
            },
            classPerks:[
                {
                    name:"Polymath",
                    description:"Gain a maneuver recovery perk",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Recovery Perk"}))
                    }
                },                
                {
                    name:"Magical Expert",
                    description:"Gain a spell and a healing spell. Every 3 levels gain an additional spell.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}))
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell", options:{type:{healing:true}}}))
                    }
                },
                {
                    name:"Powerful Healer",
                    description:"You gain 15 positive spell power, and 1% positive spell critical chance.",
                    hasCustomMethod:true,
                    skipAdd:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.spellMastery.spellPower.positive += 15
                        context.stats.characterStats.spellMastery.spellCriticalChance.positive += 1
                    }
                },
                {
                    name:"Enduring Caster",
                    description:"All spells have their spell point cost reduced by 1. This cannot reduce the cost of spells below 1.",
                },
                {
                    name:"Divine Gift",
                    description:"Start the game with a breath of life gem.",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        console.log(context.potions)
                        context.potions.ressurective.count += 1
                        let breathOfLife = {name:'Gem of Breathe of life',id:33,minLvl: 1,effect:"Cast breath of life with your level as your caster level",type:"ressurective",count:context.potions.ressurective[0].count}
                        context.connection.send(JSON.stringify({command:"usedPotion", potion:breathOfLife}))
                    }
                },
            ],
        },
        {
            name: "Shaman",
            abilityScores: "10 Str, 12 dex, 12 Con, 8 Int, 14 Wis, 8 Cha",
            hd:"1d8",
            baseStats: "1d8HD, 0 BAB, 9 SP, 2.5 SP per level, +2 Will",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 1 Untyped, 1 Magic, 1 Class\n   Feats: 1 Untyped, 1 Magic\n   Stats: 2 Untyped, 2 Skills\n   Equipment: 1 Weapons, 1 Light Armor, 50 Gold\n   Spells: lvl 1: x4(Healing, Control, Buff, Untyped), lvl 2: x2(Healing/Control, Untyped) \n   Spells Power: 10 universal spell power, 1% universal spell critical chance, 15% universal spell critical power
            \nBonus Rolls:\n    Every 3 levels: <Dark/Curse/Death/Arcane> Maneuver or Control/Buff Spell\n    Every 5 levels: +0.5 BAB or +2 Intelligence\n    Every 8 levels: Magic Perk`,  
            baseStatsMods:{
                bab:0,
                hdSize:8,
                sp:9,
                spPerLevel:2.5,
                fortitude:0,
                reflex:0,
                will:2,
                gold:50,
                abilityScores:{
                    strength:0,
                    dexterity:2,
                    constitution:2,
                    intelligence:-2,
                    wisdom:4,
                    charisma:-2,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, type:{magic:true}}, amount:1},
                {type:"feats", amount:1},
                {type:"feats", options:{magic:true}, amount:1},
                {type:"stats", amount:2},
                {type:"stats", options:{type:{skills:true}}, amount:2},
                {type:"weapon", amount:1},
                {type:"armor", options:{armor:{type:{light:true}}}, amount:2},
                {type:"spell", options:{level:{lvl1:true},type:{healing:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{control:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{buff:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"spell", options:{level:{lvl2:true},type:{healing:true,control:true}}, amount:1},
                {type:"spell", options:{level:{lvl2:true},type:defaultRolls.spellType}, amount:1},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.universal += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 15
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Dark', 'Curse','Death','Arcane']
                    let spellList = ['control','buff']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    let options = [{title:"+0.5 BAB",id:0, method:(context)=>{context.stats.characterStats.misc.BAB += 0.5}}, {title:"+2 Wisdom",id:1, method:(context)=>{context.stats.characterStats.abilityScore.wisdom += 2}}]
                    context.customDialogArray.push({title:"Class Roll Choice", options})                    
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{magic:true}}}))
                }
            },
            classPerks:[
                {
                    name:"Polymath",
                    description:"Gain a maneuver recovery perk",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Recovery Perk"}))
                    }
                },                
                {
                    name:"Magical Expert",
                    description:"Gain a spell and a control spell. Every 3 levels gain an additional spell.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell", options:{type:{control:true}}}))
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}))
                    }
                },
                {
                    name:"Powerful Caster",
                    description:"You gain a +2 bonus on spell penetration checks, and you choose one school of magic, increase the DC's of spells from that school by +1.",
                },
                {
                    name:"Enduring Caster",
                    description:"All spells have their spell point cost reduced by 1. This cannot reduce the cost of spells below 1.",
                },
                {
                    name:"Shaman's Gear",
                    description:"Start the game with 2 random implements. Every time you descend a floor, you can roll a spellcraft check, DC 10. If you meet this DC, and for every 10 you exceed it by, you gain an additional implement.",
                },
            ],
        },
        {
            name: "Alchemist",
            abilityScores: "8 Str, 12 dex, 12 Con, 14 Int, 8 Wis, 8 Cha",
            hd:"1d8",
            baseStats: "1d8HD, 0 BAB, 7 SP, 2.5 SP per level, +1 Fortitude, +2 Will",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 1 Untyped, 1 Magic, 1 Universal, 1 Class\n   Feats: 1 Untyped, 1 Utility\n   Stats: 2 Untyped, 4 Skills\n   Equipment: 1 Light Armor, 100 Gold\n   Spells: lvl 1: x3(Healing, Buff, Untyped), lvl 2: x2(Buff, Untyped) \n   Spells Power: 10 universal spell power, 10 spell power and 1% critical of a random spell type 
            \nBonus Rolls:\n    Every 3 levels: <Void/Water/Arcane> Maneuver or Healing/Buff/Utility Spell\n    Every 5 levels: +1 BAB\n    Every 8 levels: Magic Perk`,   
            baseStatsMods:{
                bab:0,
                hdSize:8,
                sp:7,
                spPerLevel:2.5,
                fortitude:1,
                reflex:0,
                will:2,
                gold:100,
                abilityScores:{
                    strength:-2,
                    dexterity:2,
                    constitution:2,
                    intelligence:4,
                    wisdom:-2,
                    charisma:-2,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, type:{magic:true}}, amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk, type:{universal:true}}, amount:1},
                {type:"feats", amount:1},
                {type:"feats", options:{utility:true}, amount:1},
                {type:"stats", amount:2},
                {type:"stats", options:{type:{skills:true}}, amount:4},
                {type:"armor", options:{armor:{type:{light:true}}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{healing:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{buff:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"spell", options:{level:{lvl2:true},type:{buff:true}}, amount:1},
                {type:"spell", options:{level:{lvl2:true},type:defaultRolls.spellType}, amount:1},
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.universal += 10
                let spellPower = ['fire', 'cold', 'acid', 'electricity', 'positive', 'negative']
                let randomSpellPower = spellPower[Math.floor(Math.random()*spellPower.length)]
                context.stats.characterStats.spellMastery.spellPower[randomSpellPower] += 10
                context.stats.characterStats.spellMastery.spellCriticalChance[randomSpellPower] += 1
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Void','Water','Arcane']
                    let spellList = ['healing','buff','utility']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    let options = [{title:"+0.5 BAB",id:0, method:(context)=>{context.stats.characterStats.misc.BAB += 0.5}}, {title:"+2 Intelligence",id:1, method:(context)=>{context.stats.characterStats.abilityScore.intelligence += 2}}]
                    context.customDialogArray.push({title:"Class Roll Choice", options})                    
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{magic:true}}}))
                }
            },
            classPerks:[
                {
                    name:"Polymath",
                    description:"Gain a maneuver recovery perk",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Recovery Perk"}))
                    }
                },                
                {
                    name:"Magical Expert",
                    description:"Gain a spell. Every 3 levels gain an additional spell.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell"}))
                    }
                },
                {
                    name:"Powerful Potions",
                    description:"Whenever you drink or apply a curative or mnemonic potion you increase the hit points or spell points restored by 15%.",
                },
                {
                    name:"Preparations",
                    description:"Start the game with 2 extra cure minor potions and 2 minor mnemonic potions. At the start of every floor gain 2 random potion.",
                },
                {
                    name:"Carrying Gold",
                    description:"Start the game with an additional 75 gold.",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.gold += 75
                    }
                },
            ],
        },
        {
            name: "Sorcerer",
            hd:"1d6",
            abilityScores: "10 Str, 12 Dex, 12 Con, 10 Int, 8 Wis, 14 Cha",
            baseStats: "1d6HD, +1 BAB, 12 SP, 4 SP per level, +2 Will",
            Rolls: `Base Rolls: \n   Perks: 1 Unique, 2 Untyped, 1 Magic, 1 Class\n   Feats: 1 Untyped, 1 Magic, 1 Metamagic\n   Stats: 2 Untyped, 2 Skills\n   Equipment: 2 Weapons, 100 Gold\n   Spells: lvl 1: x3(Damage, Control, Untyped), lvl 2: x2(Damage, Untyped) \n   Spells Power: 10 elemental spell power, 3% elemental spell critical chance, 15% elemental spell critical power
            \nBonus Rolls:\n    Every 3 levels: <Primal/Arcane/Curse/Shadow> Maneuver or Control/Damage Spell\n    Every 5 levels: +0.5 BAB or +2 Charisma\n    Every 8 levels: Metamagic Feat`,      
            baseStatsMods:{
                bab:1,
                hdSize:6,
                sp:12,
                spPerLevel:4,
                fortitude:0,
                reflex:0,
                will:2,
                gold:100,
                abilityScores:{
                    strength:0,
                    dexterity:2,
                    constitution:2,
                    intelligence:0,
                    wisdom:-2,
                    charisma:4,
                },
            },
            rollRequests:[
                {type:"perks", options:{rarity:{unique:true}},amount:1},
                {type:"perks", options:{rarity:defaultRolls.perk}, amount:2},
                {type:"perks", options:{rarity:defaultRolls.perk, type:{magic:true}}, amount:1},
                {type:"feats", amount:1},
                {type:"feats", options:{magic:true}, amount:1},
                {type:"feats", options:{metamagic:true}, amount:1},
                {type:"stats", amount:2},
                {type:"stats", options:{type:{skills:true}}, amount:2},
                {type:"weapon", amount:2},
                {type:"spell", options:{level:{lvl1:true},type:{damage:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:{control:true}}, amount:1},
                {type:"spell", options:{level:{lvl1:true},type:defaultRolls.spellTypes}, amount:1},
                {type:"spell", options:{level:{lvl2:true},type:{damage:true}}, amount:1},            
                {type:"spell", options:{level:{lvl2:true},type:defaultRolls.spellTypes}, amount:1},            
            ],
            hasCustomMethod:true,
            customMethod:(context,self)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.fire += 3
                context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 15
                context.stats.characterStats.spellMastery.spellPower.acid += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.acid += 3
                context.stats.characterStats.spellMastery.spellCriticalDamage.acid += 15
                context.stats.characterStats.spellMastery.spellPower.cold += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.cold += 3
                context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 15
                context.stats.characterStats.spellMastery.spellPower.electricity += 10
                context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 3
                context.stats.characterStats.spellMastery.spellCriticalDamage.electricity += 15
                let perks = self.classPerks
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*perks.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*perks.length)
                    chosen.push(possible)
                    let option = perks[possible]
                    let description = option.description
                    choices[x] = {
                        title:option.name,
                        description,
                        id:x,
                        method:(context =>{
                            if(option.hasCustomMethod) {
                                option.customMethod(context)
                            }
                            if(!option.skipAdd){
                                let perk = {rarity:"class", name:option.name, id:Math.random()*1000000, type:"universal",shortDesc:description, hasCustomMethod:option.hasCustomMethod}
                                context.stats.lists.perks.push(perk)
                            }
                        })
                    }                
                }
                let custom = {title:"Class Perk", options:choices}
                context.customDialogArray.push(custom)
            },
            bonusRolls:(context)=>{
                if(context.stats.characterStats.misc.level%3 == 0){
                    let maneuverList = ['Primal', 'Arcane','Curse','Shadow']
                    let spellList = ['control','damage']
                    createSpellsOrManeuversDialog(context,maneuverList,spellList)   
                }
                if(context.stats.characterStats.misc.level%5 == 0){
                    let options = [{title:"+0.5 BAB",id:0, method:(context)=>{context.stats.characterStats.misc.BAB += 0.5}}, {title:"+2 Charisma",id:1, method:(context)=>{context.stats.characterStats.abilityScore.charisma += 2}}]
                    context.customDialogArray.push({title:"Class Roll Choice", options})                    
                }
                if(context.stats.characterStats.misc.level%8 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"feats", rollAmount:6, options:{metamagic:true,}}))
                    //context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{magic:true}}}))
                }
            },
            classPerks:[
                {
                    name:"Polymath",
                    description:"Gain a maneuver recovery perk",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Recovery Perk"}))
                    }
                },
                {
                    name:"Polymath ",
                    description:"Gain a maneuver recovery perk",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Recovery Perk"}))
                    }
                },
                {
                    name:"Destructive Focus",
                    description:"Gain 2 damage spells. Every 3 levels gain an additional damage spell.",
                    skipAdd:false,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell", options:{type:{damage:true}}}))
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"spell", options:{type:{damage:true}}}))
                    }
                },
                {
                    name:"Powerful Destruction",
                    description:"Gain 15 elemental spell power and 1% elemental spell critical chance. Lose 20 positive spell power and -2% positive spell critical chance.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.spellMastery.spellPower.fire += 10
                        context.stats.characterStats.spellMastery.spellCriticalChance.fire += 1
                        context.stats.characterStats.spellMastery.spellPower.acid += 10
                        context.stats.characterStats.spellMastery.spellCriticalChance.acid += 1
                        context.stats.characterStats.spellMastery.spellPower.cold += 10
                        context.stats.characterStats.spellMastery.spellCriticalChance.cold += 1
                        context.stats.characterStats.spellMastery.spellPower.electricity += 10
                        context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 1
                        context.stats.characterStats.spellMastery.spellPower.positive -= 20
                        context.stats.characterStats.spellMastery.spellCriticalChance.positive -= 2
                    }
                },
                {
                    name:"Powerful Caster",
                    description:"You gain a +2 bonus on spell penetration checks, and you choose one school of magic, increase the DC's of spells from that school by +1.",
                },
                {
                    name:"Metamagic Expert",
                    description:"Empowering a spell with a metamagic feat does not increase the spell's casting time.",
                },
                {
                    name:"Eldritch Blood",
                    description:"Gain 6 spell points and an +1 spell points per level",
                    skipAdd:true,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.misc.spPerLevel += 1
                        context.stats.characterStats.spellpointIncreases.push(6)
                    }
                },
            ],
        },        
]

function createSpellsOrManeuversDialog(context,maneuverList,spellList){
    let options = []
    let maneuverOption ={title:"Maneuver",id:0, method:(context)=>{context.getSpellOrManeuver({name:"School Maneuver"}, {school:maneuverList})}}
    maneuverOption.description = "Maneuver from Tag of Choice: "
    maneuverList.forEach(tag=> maneuverOption.description += tag + "/")
    options.push(maneuverOption)

    let spellOption = {title:"Spell",id:1, method:(context)=>{context.getSpellOrManeuver({name:"Typed Spell"}, {type:spellList})}}
    spellOption.description = "Typed Spell from: "
    spellList.forEach(tag=> spellOption.description += tag + "/")
    options.push(spellOption)
    context.customDialogArray.push({title:"Class Roll Choice", options})
}

// fastManeuverRecovery = [
//     {
//         name:"Heroic Recovery"
//         classes:["Fighter"]
//     }
// ]